import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import { Button } from "devextreme-react/button";
import { useScreenSize } from "../../../utils/media-query";
import {
  RequestStatus,
  changeDisplayedName,
  leaveType,
  ApprovalStatus,
  handleCheckDisableButton,
  AllowApprove,
} from "../../../common";
import { useAuth } from "../../../contexts/auth";
import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";

export default function LeaveApprovalTableList({
  dataGrid,
  middleware,
  handleOpenPopup,
  approvalList,
  handleChangeSelectBox,
  filter,
  setFilter,
  handleSendApprove,
}) {
  const { user } = useAuth();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const { isXSmall, isSmall } = useScreenSize();
  const [isDisable, setIsDisable] = React.useState(true);

  const selectionPopupChanged = ({ selectedRowsData }) => {
    setSelectedItems(selectedRowsData);
    handleCheckDisableButton(selectedRowsData, setIsDisable, user);
  };

  const renderActions = ({ data }) => {
    // 0: Reject
    // 1: Approve
    const newDataApprove = { ...data, type: 1, category: "L" };
    const newDataReject = { ...data, type: 0, category: "L" };
    return (
      <>
        {/* {data.ApprovalStatus !== 0 &&
        data.ApprovalStatus !== 1 &&
        (data.RequestStatus === 0 || data.RequestStatus === 1) ? ( */}
        {data?.IsAllowApprove ? (
          <>
            <Button
              type="default"
              stylingMode="outlined"
              // text={formatMessage("Approve")}
              icon="check"
              onClick={() => handleSendApprove(newDataApprove)}
              className="button-rounded mr-2"
            />
            <Button
              type="danger"
              stylingMode="outlined"
              // text={formatMessage("Reject")}
              icon="close"
              className="button-rounded"
              // icon="close"
              onClick={() => handleOpenPopup(newDataReject)}
            />
          </>
        ) : null}
      </>
    );
  };

  return (
    <div>
      <DataGrid
        id="gridContainer"
        height={
          isXSmall || isSmall
            ? "auto"
            : document.documentElement.offsetHeight - 189
        }
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        // columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        dataSource={approvalList}
        ref={(e) => {
          dataGrid.current = e;
        }}
        onSelectionChanged={selectionPopupChanged}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        {middleware && middleware.ApproveState && (
          <Column
            caption={formatMessage("Action")}
            cellRender={renderActions}
            alignment="center"
          />
        )}
        <Column
          caption={formatMessage("RequestStatus")}
          dataField="RequestStatus"
          allowFiltering={false}
        >
          <Lookup
            dataSource={RequestStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("IsAllowApprove")}
          dataField="IsAllowApprove"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <Lookup
            dataSource={AllowApprove}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="EmployeeCode"
          dataType="string"
        />
        <Column
          caption={formatMessage("FullName")}
          dataField="FullName"
          dataType="string"
        />
        {/* <Column
          caption={formatMessage("RequestStatus")}
          dataField="RequestStatus"
          allowFiltering={false}
          hidingPriority={isXSmall ? 8 : false}
        >
          <Lookup
            dataSource={RequestStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column> */}
        <Column
          caption={formatMessage("DepartmentName")}
          dataField="Department"
          dataType="string"
        />
        <Column
          caption={formatMessage("PositionName")}
          dataField="Position"
          dataType="string"
        />
        <Column
          caption={formatMessage("FromDate")}
          dataField="FromDate"
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Column
          caption={formatMessage("ToDate")}
          dataField="ToDate"
          dataType="date"
          format="dd/MM/yyyy"
        />
        {/* <Column
          caption={formatMessage("StartTime")}
          dataField="StartTime"
          dataType="string"
          hidingPriority={isXSmall ? 5 : false}
          // width={120}
        />
        <Column
          caption={formatMessage("EndTime")}
          dataField="EndTime"
          dataType="string"
          hidingPriority={isXSmall ? 6 : false}
          // width={120}
        /> */}
        <Column caption={formatMessage("LeaveType")} dataField="LeaveType">
          <Lookup
            dataSource={leaveType}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("SymbolName")}
          dataField="SymbolCode"
          dataType="string"
        />
        {/* <Column
          caption={formatMessage("DeductionHour")}
          dataField="DeductionHour"
          dataType="number"
          hidingPriority={isXSmall ? 6 : false}
          // width={120}
        /> */}
        {/* <Column
          caption={formatMessage("LeaveHour")}
          dataField="LeaveHour"
          dataType="number"
          hidingPriority={isXSmall ? 6 : false}
          // width={120}
        /> */}
        {/* <Column
          caption={formatMessage("ManDays")}
          dataField="ManDays"
          dataType="number"
          hidingPriority={isXSmall ? 7 : false}
        /> */}
        <Column
          caption={formatMessage("TotalDays")}
          dataField="TotalDays"
          dataType="double"
        />
        <Column
          caption={formatMessage("Description")}
          dataField="Description"
          dataType="string"
        />
        {/* <Column
          caption={formatMessage("LeaveTotal")}
          dataField="LeaveTotal"
          dataType="number"
        />
        <Column
          caption={formatMessage("LeaveUsed")}
          dataField="LeaveUsed"
          dataType="number"
        />
        <Column
          caption={formatMessage("LeaveRemain")}
          dataField="LeaveRemain"
          dataType="number"
        /> */}
        <Column
          caption={formatMessage("CancelReason")}
          dataField="CancelReason"
          dataType="string"
        />
        <Column
          caption={formatMessage("CanceledDate")}
          dataField="CanceledDate"
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Column
          caption={formatMessage("ApprovalStatus")}
          dataField="ApprovalStatus"
          // allowFiltering={false}
        >
          <Lookup
            dataSource={ApprovalStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("FirstApprovalName")}
          dataField="FirstApprovalName"
          dataType="string"
        />
        <Column
          caption={formatMessage("ApprovedByName")}
          dataField="LastApprovalName"
          dataType="string"
        />
        <Column
          caption={formatMessage("ApprovedDate")}
          dataField="ApprovedDate"
          dataType="date"
          format="dd/MM/yyyy"
          // width={120}
        />
        <Column
          caption={formatMessage("ApprovalComments")}
          dataField="ApprovalComments"
          dataType="string"
        />
        <Column caption={formatMessage("CreatedBy")} dataField="CreatedBy" />
        <Column
          caption={formatMessage("CreatedDate")}
          dataField="CreatedDate"
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Column caption={formatMessage("UpdatedBy")} dataField="UpdatedBy" />
        <Column
          caption={formatMessage("UpdatedDate")}
          dataField="UpdatedDate"
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Toolbar>
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              filter={filter}
              setFilter={setFilter}
              handleChangeSelectBox={handleChangeSelectBox}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter
              selectedItems={selectedItems}
              middleware={middleware}
              handleOpenPopup={handleOpenPopup}
              dataGrid={dataGrid}
              isDisable={isDisable}
              handleSendApprove={handleSendApprove}
            />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
